export default {
  defaultSortField: 'name',
  defaultSortOrder: 'asc',
  isCheckable: true,
  hasCheckBox: true,
  isDetailed: false,
  customRowKey: 'uuid',
  toolBar: {
    hideSearchBar: false,
  },
  fields: [
    {
      name: 'itemSelect',
      width: '40px',
      title: '',
    },
    {
      name: 'viewBIM',
      width: '40px',
      title: '',
    },
    {
      name: 'notes',
      title: '',
      defaultVisible: true,
      width: '40px',
      id: 'notes',
    },
    {
      title: 'Production Order Name*',
      name: 'field-generic-input',
      width: '296px',
      id: 'name',
      prop: 'name',
      inputProps: {
        type: 'text',
        disableEdit: false,
      },
    },
    {
      name: 'field-generic-input',
      width: '152px',
      title: 'Order ID',
      id: 'uniqueOrderId.value',
      prop: 'uniqueOrderId.value',
      inputProps: {
        type: 'text',
        disableEdit: false,
      },
    },
    {
      title: 'Description',
      name: 'field-generic-input',
      width: '200px',
      id: 'financialId',
      prop: 'financialId',
      defaultVisible: true,
      inputProps: {
        type: 'text',
        disableEdit: false,
      },
    },
    {
      name: 'templateSelect',
      width: '320px',
      title: 'Template',
      id: 'template',
    }, 
    {
      name: 'shipBy',
      defaultVisible: false,
      width: '112px',
      title: 'Detail By*',
      id: 'poDetailBy',
      prop: 'poDetailBy',
      isEdit: true,
      isModal: true,
      kind: 'dates',
      inputProps: {
        min: 'coord',
        kind: 'poDetailBy',
        max: 'deliver',
      },
    },
    {
      name: 'deliverBy',
      defaultVisible: false,
      width: '112px',
      title: 'Onsite*',
      id: 'onSiteBy',
      prop: 'deliver',
      isEdit: true,
      kind: 'dates',
      inputProps: {
        kind: 'deliver',
        min: 'poDetailBy',
      },
    },
    {
      title: 'Fabrication Facility*',
      name: 'location-select',
      width: '296px',
      id: 'locations',
      dataClass: 'overflow-visible',
    }, 
    {
      name: 'owner-select',
      title: 'Owner*',
      width: '224px',
      id: 'owner',
    },
    {
        name: 'level-select',
        prop: 'level',
        width: '160px',
        title: 'Level',
        id: 'level',
        inputProps: {
          options: 'levels',
          isEditing: true,
        },
    },
    {
        name: 'zone-select',
        prop: 'zone',
        width: '160px',
        title: 'Zone',
        id: 'zone',
        inputProps: {
          options: 'zones',
          isEditing: true,
        },
    }
  ],
};
